export const EVENT_TYPE_OPTIONS = [
    { value: "sortie_scolaire", label: "Sortie scolaire" },
    { value: "atelier_pedagogique", label: "Atelier pédagogique" },
    { value: "team_building", label: "Team building" },
    { value: "evenement_entreprise", label: "Événement entreprise" },
    { value: "anniversaire_enfant_groupe", label: "Anniversaire enfant / groupe" },
    { value: "autre", label: "Autre" },
];

export const LOCATION_OPTIONS = [
    {
        value: "client_establishment",
        label: "Dans notre établissement (école / entreprise)",
    },
    {
        value: "other_place",
        label: "Autre lieu",
    },
];